<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <select
            ref="handle"
            class="input"
            :value="value"
            :class="options"
            @input="update()"
            v-bind="$attrs"
            slot="input">
            <option v-if="preselect" :selected="!value || value == 0 ? true : false" value="" disabled v-html="preselect"></option>
            <option v-for="(option, index) in items" :key="index" v-html="option.label" :value="option.value" :selected="option == value ? true : false"></option>
        </select>
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    export default {
        name: 'app-field-select',
        components: {
            'app-field': Field,
            'app-label': Label
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            },
            items: {
                type: Array,
                required: true
            },
            preselect: {
                type: String,
                required: false
            }
        },
        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },
        methods: {
            update() {
                this.$emit('input', this.$refs.handle.value)
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>



// WEBPACK FOOTER //
// src/components/fields/inputs/Select.vue